import {createAction as createActionCreator} from 'redux-actions';
import {Map, fromJS} from 'immutable';

import * as constants from '../../constants';

const NAMESPACE = `${constants.NAMESPACE}/parent`;

// Actions
const SAVE = `${NAMESPACE}/SAVE`;
const RESET = `${NAMESPACE}/RESET`;

// Reducer
export default function reducer(state = Map(), action = {}) {
  // Make sure rehidrated state gets converted to immutable
  if (!Map.isMap(state)) {
    console.warn(`state is no Map but ${typeof state} -> converting to Map NOW.`);
    state = fromJS(state);
  }

  switch (action.type) {
    case SAVE:
      return setParentData(action.payload);
    case RESET:
      return Map();
    default:
      return state;
  }
}

function setParentData(payload) {
  return Map(payload);
}

export function getParentDataAsPOJO(state) {
  return {
    vorname: state.get('vorname'),
    nachname: state.get('nachname'),
    strasse: state.get('strasse'),
    plz: state.get('plz'),
    ort: state.get('ort'),
    email: state.get('email'),
    telefonPrivat: state.get('telefonPrivat'),
    telefonMobil: state.get('telefonMobil'),
    telefonGeschaeftlich: state.get('telefonGeschaeftlich'),
    einverstaendnisWaehrendDerWoche: state.get('einverstaendnisWaehrendDerWoche'),
  }
}

const save = createActionCreator(SAVE);
export function saveParentData(vorname, nachname, strasse, plz, ort, email, telefonPrivat, telefonMobil, telefonGeschaeftlich, einverstaendnisWaehrendDerWoche) {
  return save(
    {
      vorname,
      nachname,
      strasse,
      plz,
      ort,
      email,
      telefonPrivat,
      telefonMobil,
      telefonGeschaeftlich,
      einverstaendnisWaehrendDerWoche,
    }
  );
}

const resetActionCreator = createActionCreator(RESET);
export function reset() {
  return resetActionCreator();
}



// WEBPACK FOOTER //
// ./src/components/parent/parent.js